import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import {
  FornecedorImposto,
  FormFornecedorImposto,
} from "core/features/fornecedores/typings/index";
import { Control, UseFormSetValue } from "react-hook-form";
import { Checkbox } from "@chakra-ui/react";
import SelectImpostos from "components/Input/SelectImpostos/index";
import SelectAliquota, {
  TipoAliquota,
} from "ui/components/Input/SelectAliquota/index";

interface ImpostoItemProps {
  control: Control<FornecedorImposto, any>;
  setValue: UseFormSetValue<FornecedorImposto>;
  impostos: FormFornecedorImposto[];
  index: number;
}

function ImpostosItem({
  control,
  index,
  impostos,
  setValue,
}: ImpostoItemProps) {
  const onRemove = (index: number) => {
    const copy = [...impostos];

    copy.splice(index, 1);

    setValue("impostos", copy);
  };

  return (
    <Row gutter={16}>
      <Col sm={7}>
        <Field
          label="Imposto"
          control={control}
          name={`impostos.${index}.impostoId`}
          render={({ field, isInvalid }) => (
            <SelectImpostos
              placeholder="Selecione o imposto"
              value={field.value}
              onChange={(v, option) => {
                field.onChange(v);
                setValue(`impostos.${index}.imposto`, option as any);
              }}
              isInvalid={isInvalid}
            />
          )}
        />
      </Col>

      <Col sm={7}>
        {impostos[index].impostoId ? (
          <Field
            label={"Aliquota"}
            control={control}
            name={`impostos.${index}.aliquotaId`}
            render={({ field }) => (
              <SelectAliquota
                placeholder=""
                value={field.value}
                onChange={(v) => {
                  field.onChange(v);
                }}
                imposto={impostos[index].imposto}
              />
            )}
          />
        ) : null}
      </Col>

      <Col sm={4}>
        {impostos[index].aliquotaId === TipoAliquota.AliquotaFornecedor ? (
          <Field
            label={"Aliquota(%)"}
            control={control}
            rules={{ required: true }}
            shouldUnregister
            name={`impostos.${index}.aliquota`}
            render={({ field, isInvalid }) => (
              <InputMoney isInvalid={isInvalid} {...field} />
            )}
          />
        ) : null}
      </Col>

      <Col sm={4}>
        <Field
          control={control}
          name={`impostos.${index}.reterImposto`}
          render={({ field, isInvalid }) => (
            <Checkbox
              mt={7}
              isChecked={field.value}
              isInvalid={isInvalid}
              onChange={() => {
                field.onChange(!field.value);
              }}
            >
              Reter imposto
            </Checkbox>
          )}
        />
      </Col>

      <Col sm={2}>
        <AddRemoveLineButton
          showAdd={false}
          onRemove={() => onRemove(index)}
          containerProps={{
            pt: 4,
          }}
        />
      </Col>
    </Row>
  );
}

export default ImpostosItem;
